import script from "./sport-live-tv-filter-group.vue?vue&type=script&setup=true&lang=js"
export * from "./sport-live-tv-filter-group.vue?vue&type=script&setup=true&lang=js"

import "./sport-live-tv-filter-group.vue?vue&type=style&index=0&id=b509bb76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b509bb76"]])

export default __exports__